var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7026 5.29159C13.4943 4.08325 11.8359 3.33325 9.99427 3.33325C6.31094 3.33325 3.33594 6.31659 3.33594 9.99992C3.33594 13.6833 6.31094 16.6666 9.99427 16.6666C13.1026 16.6666 15.6943 14.5416 16.4359 11.6666H14.7026C14.0193 13.6083 12.1693 14.9999 9.99427 14.9999C7.23594 14.9999 4.99427 12.7583 4.99427 9.99992C4.99427 7.24159 7.23594 4.99992 9.99427 4.99992C11.3776 4.99992 12.6109 5.57492 13.5109 6.48325L10.8276 9.16658H16.6609V3.33325L14.7026 5.29159Z",
    fill: "#DC6803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.da8a8d94d8310bd8700ed52f4a9f0a77.svg";
export { ForwardRef as ReactComponent };